import React from 'react';
import { Skeleton } from 'antd';
import type { UserInfo } from '@/stores/account';
import { ApplicationInfo } from '@/const/application';
import './index.less';

interface HeaderLeftContentProps {
  userInfo?: UserInfo;
}
const HeaderLeftContent: React.FC<HeaderLeftContentProps> = ({ userInfo }) => {
  return (
    <>
      <div className="fle-layout-header-left-content">
        <div className="fle-layout-header-logo" style={{ height: 32 }}>
          {userInfo ? (
            <>
              {/* <img src={userInfo?.portalLogo || ApplicationInfo.textLogo} alt="logo" /> */}
              <img src='https://oss.elebuys.com/202506181515080005105620.png' alt="logo" />
            </>
          ) : (
            <Skeleton.Button style={{ width: 100 }} active />
          )}
        </div>
      </div>
    </>
  );
};
export default React.memo(HeaderLeftContent);
